<template>
  <container>
    <div id="depoimentos" class="relative w-full h-full overflow-hidden mt-16">
      <div class="w-full text-center">
        <title-component title="Depoimentos de Nosso Pacientes"
                         sub-title="Vamos ver o que nosso pacientes dizem sobre nossos resultados"/>
      </div>

      <!-- Carousel -->
      <div class="relative">
        <!-- Botão Anterior -->
        <button
            class="absolute left-1 top-1/2 transform -translate-y-1/2 z-10 bg-white/70 hover:bg-white p-2 rounded-full shadow text-4xl"
            @click="prevSlide"
            :disabled="currentIndex === 0"
        >
          ‹
        </button>

        <!-- Carousel conteúdo -->
        <div
            class="flex mx-12 transition-transform duration-300 ease-in-out"
            :style="{ transform: `translateX(-${currentIndex * 80}%)` }"
        >
          <div
              class="flex-shrink-0 w-3/4 lg:w-1/4 mr-4 lg:mr-12"
              v-for="(image, index) in images"
              :key="index"
          >
            <template v-if="image.includes('/')">
              <img
                  :src="image"
                  :alt="'Image ' + index"
                  class="rounded-md h-[300px] md:h-[600px]"
                  width="500"
                  height="500"
              />
            </template>
            <template v-else>
              <iframe
                  width="100%"
                  :src="`https://www.youtube.com/embed/${image}/?rel=0`"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen
                  class="rounded-md h-[300px] md:h-[600px]"
              ></iframe>
            </template>
          </div>
        </div>

        <!-- Botão Próximo -->
        <button
            class="absolute right-1 top-1/2 transform -translate-y-1/2 z-10 bg-white/70 hover:bg-white p-2 rounded-full shadow text-4xl"
            @click="nextSlide"
            :disabled="currentIndex >= maxIndex"
        >
          ›
        </button>
      </div>

      <!-- Botão Ver mais -->
      <div class="w-full flex justify-end mt-12 pr-2 pb-2">
        <button
            class="border border-blue-600 bg-white hover:scale-105 active:scale-95 p-2 rounded-md mb-4 lg:mb-0 lg:w-52">
          <a href="https://www.instagram.com/stories/highlights/17900304406687433/" target="t_blank" title="Ver mais"
             rel="noopener noreferrer">
            <span class="text-sm text-blue-600 lg:text-xl">Ver mais</span>
          </a>
        </button>
      </div>
    </div>
  </container>
</template>

<script>
import Container from '@/components/partials/Container.vue'
import TitleComponent from "@/components/TitleComponent.vue";

export default {
  name: 'TestimonialComponent',
  components: {
    Container,
    TitleComponent
  },
  data() {
    return {
      currentIndex: 0,
      screenWidth: window.innerWidth,
      images: [
        'd108djB74JY',
        '5gu0-1QNENY',
        'iZqNOfZCOF0',
        '1tpatYg2G3U',
        'j42eGPQqB-Y',
        'r1j_EQhPHms',
        '/002.webp',
        '/001.webp',
        '/004.webp',
        '/005.webp',
        '/006.webp',
        '/007.webp',
        '/008.webp',
        '/009.webp',
        '/010.webp',
        '/011.webp',
        '/012.webp',
        '/013.webp',
        '/014.webp',
        '/015.webp',
      ]
    };
  },
  computed: {
    //se adicionar mais imagens ou videos diminua o número 5, use o debug abaixo para ver o total de imagens e faça o ajuste
    maxIndex() {
      if (this.screenWidth > 1200) {
        return Math.floor(this.images.length) - 13;
      }
      return Math.floor(this.images.length);
    }
  },
  methods: {
    nextSlide() {
      if (this.currentIndex < this.maxIndex) {
        //este debug que diz quanto deve ser o valor de 5, use o console e limite a quantidade de cliques no botão avançar
        // console.log(this.currentIndex, this.maxIndex, this.screenWidth);
        this.currentIndex++;
      }
    },
    prevSlide() {
      if (this.currentIndex > 0) {
        this.currentIndex--;
      }
    }
  },
  mounted() {
    const logScreenSize = () => {
      this.screenWidth = window.innerWidth
    };
    window.addEventListener('resize', logScreenSize);
    logScreenSize();
  },
}
</script>
